<!--Componente de imagen para mostrarlo como un v-dialog-->
<template>
    <v-dialog v-model="dialog" class="pa-0" content-class="pa-0" width="unset">
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="accent">fas fa-image</v-icon>
        </template>

        <v-card class="pa-0 ma-0 card-container">
            <v-img :src="img" class="card-img"/>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:{
        img: { type: String, required:true }
    },
    data(){
        return{
            dialog:false,
        }
    },
    computed:{
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:3.5em'
                case 'sm': return 'font-size:3.5em'
                case 'md': return 'font-size:4em'
                case 'lg': return 'font-size:5em'
                case 'xl': return 'font-size:6em'
            }
        }
    }
}
</script>
<style scoped>
.card-container{
    height: fit-content;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
}

.card-img{
    height: 100%;
    max-height: 70vh;
    width: auto;
    max-width: 70vw;
    object-fit: contain;
}

@media (max-width: 369px) {
    .card-img{
        max-height: 70vh!important;
        max-width: 85vw!important;
    }
}

@media (min-width: 370px) and (max-width: 450px) {
    .card-img{
        max-height: 70vh!important;
        max-width: 85vw!important;
    }
}
@media (min-width: 451px) and (max-width: 599px){
    .card-img{
        max-height: 65vh!important;
        max-width: 75vw!important;
    }
}

@media (min-width: 600px) and (max-width: 959px)  {
    .card-img{
        max-height: 65vh!important;
        max-width: 80vw!important;
    }
}

@media (min-width: 960px) and (max-width: 1263px) and (max-height: 1000px) {
    .card-img{
        max-height: 70vh!important;
        max-width: 70vw!important;
    }
}

@media (min-width: 960px) and (max-width: 1263px) and (min-height: 1001px){
    .card-img{
        max-height: 70vh!important;
        max-width: 85vw!important;
    }
} 
@media (min-width: 1264px) and (max-width: 1499px) and (orientation: landscape)  {
    .card-img{
        max-height: 70vh!important;
        max-width: 70vw!important;
    }
}
@media (min-width: 1264px) and (max-width: 1499px) and (orientation: landscape) and (max-height:1000px)  {
    .card-img{
        max-height: 70vh!important;
        max-width: 70vw!important;
    }
}
@media (min-width: 1264px) and (max-width: 1499px) and (orientation: portrait){
    .card-img{
        max-height: 75vh!important;
        max-width: 75vw!important;
    }
}
@media (min-width: 1500px) and (max-width: 1903px) {
    .card-img{
        max-height: 70vh!important;
        max-width: 70vw!important;
    }
}
@media (min-width: 1904px) {
    .card-img{
        max-height: 65vh!important;
        max-width: 80vw!important;
    }
}
</style>